import { render, staticRenderFns } from "./BalanceView.vue?vue&type=template&id=fdaca30c&scoped=true"
import script from "./BalanceView.vue?vue&type=script&lang=js"
export * from "./BalanceView.vue?vue&type=script&lang=js"
import style0 from "./BalanceView.vue?vue&type=style&index=0&id=fdaca30c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdaca30c",
  null
  
)

export default component.exports